import 'css-chunksrc/feature/settings/SettingsCardReader.module.scss';export default {
  "root": "SettingsCardReader_root"
};